'use client';

import { createContext } from 'react';

import type { DatePickerRootContextInterface } from '../types/date-picker-root.types';

export const DatePickerRootContext = createContext({} as DatePickerRootContextInterface);

DatePickerRootContext.displayName = 'DatePicker.Root.Context';
